/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import styles from "./Category.module.scss";
import {
  Avatar,
  Button,
  Flex,
  Layout,
  Space,
  Table,
  Tag,
  Typography,
  message,
  Popconfirm,
  Input,
  Dropdown,
  Modal,
  Radio,
} from "antd";
import type { TableProps, GetProp, MenuProps, RadioChangeEvent } from "antd";
import PageTitle from "components/PageTitle";
import { T_Category } from "dtos/category.dto";
import type { SorterResult, FilterValue } from "antd/es/table/interface";
import { BlogStatusTypes, BlogVisibilityTypes } from "dtos/blog.dto";
import { BLOG_VISIBILITY_COLOURS, CATEGORY_TYPE_COLOURS } from "utils/constants";
import { T_Category_Type } from "dtos/category.dto";
import { ApiService } from "api/api.service";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import type { PopconfirmProps } from "antd";
import { TbTrash, TbEdit, TbPlus, TbDots, TbEye } from "react-icons/tb";
import DashboardLayout from "layout/DashboardLayout";
import { BLOG_VISIBILITY_LABELS } from "pages/BlogsAll/BlogsAll";
import { useAppSelector } from "store";
import { RoleTypes } from "dtos/user.dto";
interface DataType extends T_Category {}

type TablePaginationConfig = Exclude<GetProp<TableProps, "pagination">, boolean>;
interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const items: MenuProps["items"] = [
  {
    label: "Change Visibility",
    key: "1",
    icon: <TbEye />,
  },
];
const Category = () => {
  const currentUser = useAppSelector((state) => state.user);
  const [serachParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState<{
    page: number;
    limit: number;
    visibility?: string[];
    type?: T_Category_Type[];
  }>({
    page: Number(serachParams.get("page")) === 0 ? 1 : (Number(serachParams.get("page")) ?? 1),
    limit: Number(serachParams.get("limit")) === 0 ? 10 : (Number(serachParams.get("limit")) ?? 10),
    type: [],
    visibility: [],
  });
  const deleteCategory = ApiService.category.useDeleteByIdOrSlug();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedVisibility, setSelectedVisibility] = useState({ init: "", later: "" });
  const [selectedStory, setSelectedStory] = useState("");
  const [highlightedRow, setHighlightedRow] = useState<string | null>(null);
  const searchCategory = ApiService.category.useSearchCategory({
    page: filters.page,
    limit: filters.limit,
    term: searchTerm,
  });
  const updateVisibility = ApiService.category.useUpdateVisibility();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedcategory] = useState("");
  const [openVisibilityModal, setOpenVisibilityModal] = useState(false);
  const categoryList = ApiService.category.useGetAllPaginated({
    page: filters.page,
    limit: filters.limit,
    type: filters.type,
    visibility: filters.visibility,
  });

  const formatTypes = (value: string) => {
    const formattedvalue = value.replace(/_/g, " ");
    return formattedvalue[0].toUpperCase() + formattedvalue.slice(1).toLowerCase();
  };

  const handleRowUpdate = (rowKey: string) => {
    setHighlightedRow(rowKey);

    // Clear the highlight after 1 second
    setTimeout(() => {
      setHighlightedRow(null);
    }, 1000);
  };

  const handleDropDownSelect = (visibility: string, id: string) => {
    // console.log(visibility, status);
    setSelectedVisibility({ init: visibility, later: visibility });

    setSelectedStory(id);
  };
  const handleMenuClick: MenuProps["onClick"] = (e) => {
    // message.info("Click on menu item.");
    e.key === "1" ? setOpenVisibilityModal(true) : "";
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  const handleVisibilityChange = () => {
    updateVisibility.mutate(
      { id: selectedStory, visiblity: selectedVisibility.later },
      {
        onSuccess: () => {
          message.success("Visibility updated successfully");
          categoryList.refetch();
          setOpenVisibilityModal(false);
          handleRowUpdate(selectedStory);
        },
      },
    );
  };
  const columns: TableProps<DataType>["columns"] = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 230,
      ellipsis: true,
      render: (name: string, record: DataType, index: number) => {
        return (
          <Flex align="center" gap={8}>
            <Avatar
              size={"large"}
              style={{ backgroundColor: "#2c362f", fontSize: "20px", minHeight: 40, minWidth: 40 }}
            >
              {record.title.charAt(0).toUpperCase()}
            </Avatar>
            {/* <Link to={`/dashboard/category/${record.slug}`}> */}
            <Typography.Title style={{ marginTop: 8 }} level={5} className="w-[180px]">
              {record.title}
            </Typography.Title>
            {/* </Link> */}
          </Flex>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 300,

      render: (name: string, record: DataType, index: number) => {
        return (
          <Typography.Paragraph type="secondary" className="w-[300px]">
            <small>
              {record.description?.substring(0, 50)}
              {record.description?.length > 50 ? "..." : ""}
            </small>
          </Typography.Paragraph>
        );
      },
    },
    {
      title: "Blog Count",
      dataIndex: "blogCount",
      key: "blogCount",
      width: 150,
      align: "center",
      render: (name: string, record: DataType, index: number) => {
        return (
          <Typography.Paragraph
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/dashboard/blogs/?cat=${record._id}&val=${record.title.split(" ").join("-")}`)}
            type="secondary"
          >
            {record.blogCount}
          </Typography.Paragraph>
        );
      },
    },
    {
      title: "Visibility",
      dataIndex: "visbility_type",
      width: 150,
      key: "visbility_type",

      render: (value: string) => {
        const visibilityType = value as BlogVisibilityTypes;
        const type = visibilityType.replace(/_/g, " ");
        return <Tag color={BLOG_VISIBILITY_COLOURS[visibilityType]}>{BLOG_VISIBILITY_LABELS[visibilityType]}</Tag>;
      },
      filters: Object.keys(BlogVisibilityTypes).map((type) => {
        return {
          text: (
            <Tag color={BLOG_VISIBILITY_COLOURS[type as BlogVisibilityTypes]}>
              {BLOG_VISIBILITY_LABELS[type as BlogVisibilityTypes]}
            </Tag>
          ),
          value: type,
        };
      }),
      onFilter: (value, record) => record.visbility_type === value,
      filterSearch: true,
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 150,
      key: "type",
      filters: Object.keys(T_Category_Type).map((type) => {
        return {
          text: <Tag color={CATEGORY_TYPE_COLOURS[type as T_Category_Type]}>{formatTypes(type)}</Tag>,
          value: type,
        };
      }),
      render: (value: string) => {
        const categoryType = value as T_Category_Type;
        return <Tag color={CATEGORY_TYPE_COLOURS[categoryType]}>{formatTypes(categoryType)}</Tag>;
      },
      onFilter: (value, record) => record.type === value,
      filterSearch: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "start",
      width: 150,
      render: (name: string, record: DataType, index: number) => {
        return (
          <Flex justify="center" align="center" gap={2}>
            {/* <div>
              {record.title.toLocaleLowerCase() === "Default Category".toLocaleLowerCase() ? (
                <span style={{ cursor: "not-allowed" }}>
                  <TbEdit style={{ fontSize: "20px" }} />
                </span>
              ) : (
                <Link to={`/dashboard/category/${record.slug}`} type="text">
                  <Button icon={<TbEdit style={{ fontSize: "20px" }} />} type="text" />
                </Link>
              )}
            </div> */}
            <Button
              onClick={() => navigate(`/dashboard/category/${record.slug}?page=${filters.page}&limit=${filters.limit}`)}
              icon={<TbEdit style={{ fontSize: "20px" }} />}
              type="text"
            />
            {currentUser?.role ? (
              [RoleTypes.SUPERADMIN, RoleTypes.ADMIN, RoleTypes.CONTENT_ADMIN].includes(currentUser?.role) ? (
                <Popconfirm
                  title="Delete the category"
                  description="Are you sure to delete this category?"
                  onConfirm={confirm}
                  onCancel={cancel}
                  okButtonProps={{}}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    onClick={() => setSelectedcategory(record._id)}
                    type="text"
                    disabled={record.title.toLocaleLowerCase() === "Default Category".toLocaleLowerCase()}
                    icon={<TbTrash style={{ color: "red", fontSize: "20px" }} />}
                  ></Button>
                </Popconfirm>
              ) : null
            ) : null}
            <Dropdown trigger={["click"]} menu={menuProps}>
              <Button
                onClick={() => handleDropDownSelect(record.visbility_type, record._id)}
                icon={<TbDots style={{ fontSize: "20px" }} />}
                type="text"
              />
            </Dropdown>
          </Flex>
        );
      },
    },
  ];

  const handleTableChange = (pagination: TablePaginationConfig, keyFilters: Record<string, any[] | null>) => {
    const blogType = keyFilters.type || [];
    const visibilityFilters = keyFilters.visbility_type || [];
    setFilters({
      page: pagination.current ?? 1,
      limit: pagination.pageSize ?? 10,
      type: blogType,
      visibility: visibilityFilters,
    });
  };
  // const confirm: PopconfirmProps["onConfirm"] = (e) => {
  //   deleteCategory.mutate(selectedCategory, {
  //     onSuccess: () => {
  //       message.success("category deleted successfullt");
  //       categoryList.refetch();
  //     },
  //     onError: () => {
  //       message.error("Operation failed !!");
  //     },
  //   });
  // };

  const cancel: PopconfirmProps["onCancel"] = (e) => {};

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const confirm = (e: any) => {
    try {
      deleteCategory.mutate(selectedCategory, {
        onSuccess: () => {
          message.success("Category deleted successfully");
          if (searchTerm) {
            searchCategory.refetch();
          } else {
            categoryList.refetch();
          }
        },
        onError: () => {},
      });
    } catch (error: any) {
      console.log(error);
      message.error(`category can't be deleted ${error.errorFields[0].errors[0]}`);
    }
  };

  useEffect(() => {
    let getSearchData: NodeJS.Timeout | undefined;

    if (searchTerm !== "") {
      getSearchData = setTimeout(() => {
        searchCategory.refetch();
      }, 2000);
    }

    return () => {
      if (getSearchData) clearTimeout(getSearchData);
    };
  }, [searchTerm]);

  // useEffect(() => {
  //   if (serachParams.has("page") && serachParams.has("limit")) {
  //     setFilters({
  //       ...filters,
  //       page: Number(serachParams.get("page")) as number,
  //       limit: Number(serachParams.get("limit")) as number,
  //     });
  //   }
  // }, [serachParams]);

  return (
    <DashboardLayout
      headerRight={
        <Button
          type="primary"
          onClick={() => {
            navigate(`/dashboard/create-category`);
          }}
          icon={<TbPlus />}
        >
          Create Category
        </Button>
      }
    >
      <PageTitle title="Category" pageTitle={[{ title: "Category" }]} />
      <Input.Search
        placeholder="Search categories..."
        value={searchTerm}
        onChange={handleSearch}
        className={styles.search_container}
      />
      <Table
        virtual
        loading={searchTerm ? searchCategory.isLoading : categoryList.isLoading}
        columns={columns}
        onChange={handleTableChange}
        dataSource={searchTerm ? searchCategory.data?.data : categoryList.data?.data}
        pagination={{
          showSizeChanger: true,
          total: searchTerm ? searchCategory.data?.totalObjects : categoryList.data?.totalObjects,
          pageSize: filters.limit,
          current: filters.page,
          onChange: (page, pageSize) => {
            setFilters((prev) => ({ ...prev, page, limit: pageSize }));
          },
        }}
        rowClassName={(record) => (record._id === highlightedRow ? "highlighted-row" : "")}
      />
      <Modal
        title={`Change visibility`}
        open={openVisibilityModal}
        onOk={handleVisibilityChange}
        onCancel={() => setOpenVisibilityModal(false)}
        okButtonProps={{
          disabled: selectedVisibility.init === selectedVisibility.later,
          loading: updateVisibility.isPending,
        }}
      >
        <Radio.Group
          value={selectedVisibility.later}
          onChange={(e: RadioChangeEvent) => setSelectedVisibility({ ...selectedVisibility, later: e.target.value })}
          options={Object.values(BlogVisibilityTypes).map((type) => ({
            label: formatTypes(type),
            value: type,
          }))}
        />
      </Modal>
    </DashboardLayout>
  );
};

export default Category;
